export enum LoginExceptionCode {
    UNKNOWN,
    INVALID_USER_OR_PASSWORD,
    INVALID_EMAIL,
    WAREHOUSE_DISABLED,
    UNSUPPORTED_PROFILE,
    UNABLE_TO_GET_USER,
    PENDING_ACCEPT_LEGAL_TERMS,
    USER_DISABLED,
    NETWORK_REQUEST_FAILED,
    VISIBILITY_CHECK_WAS_UNAVAILABLE,
    REQUESTS_FROM_REFERER_BLOCKED
}
